import React, { useRef, useContext, useEffect, useState } from 'react'
import styled from 'styled-components'

import { UserContext } from '../context/user'
import { ReactComponent as PersonIcon } from '../assets/icons/person.svg'
import { ReactComponent as PersonIconOff } from '../assets/icons/person_off.svg'
import { ReactComponent as MicIcon } from '../assets/icons/mic.svg'
import { ReactComponent as MicIconOff } from '../assets/icons/mic_off.svg'
import { ReactComponent as RatioIcon } from '../assets/icons/ratio.svg'

export default () => {
	const { state } = useContext(UserContext)

	const [calling, set_calling] = useState(false)
	const [muted, set_muted] = useState(true)
	const [shown, set_shown] = useState(true)
	const [full, set_full] = useState(false)

	const local = useRef<HTMLVideoElement>(null)
	const remote = useRef<HTMLVideoElement>(null)

	const {
		local: { peer },
		remote: { id: remote_id },
	} = state

	const get_stream = () =>
		navigator.mediaDevices.getUserMedia({ video: true, audio: true })

	const call = async () => {
		const stream = await get_stream()
		local.current.srcObject = stream

		const call = peer.call(remote_id, stream)

		call.on('stream', (stream) => {
			set_calling(true)
			remote.current.srcObject = stream
		})
	}

	useEffect(() => {
		peer.on('call', async (call) => {
			const stream = await get_stream()
			local.current.srcObject = stream

			call.answer(stream)

			call.on('stream', (stream) => {
				set_calling(true)
				remote.current.srcObject = stream
			})
		})
	}, [peer])

	return (
		<Container>
			{!calling && <Button onClick={call}>start voice/video call</Button>}

			<Local ref={local} autoPlay muted shown={shown} />

			<Wrapper>
				<Remote ref={remote} autoPlay muted={muted} full={full} />
			</Wrapper>

			<Buttons>
				<Button onClick={() => set_shown(!shown)}>
					{shown ? <PersonIconOff /> : <PersonIcon />}
				</Button>

				<Button onClick={() => set_muted(!muted)}>
					{muted ? <MicIcon /> : <MicIconOff />}
				</Button>

				<Button onClick={() => set_full(!full)}>
					<RatioIcon />
				</Button>
			</Buttons>
		</Container>
	)
}

const Container = styled.section`
	flex: 1;
	display: flex;
	justify-content: center;
	align-items: center;
	overflow: hidden;
	background: ${({ theme: { colors } }) => colors.black[1]};
`
const Local = styled.video<{ shown? }>`
	position: absolute;
	top: 1rem;
	left: 1rem;
	z-index: 2;
	height: 4rem;
	opacity: ${({ shown }) => !shown && '0'};
`
const Wrapper = styled.div`
	position: absolute;
	overflow: hidden;
	top: 0;
	left: 0;
	height: 100vh;
	width: 100vw;
`
const Remote = styled.video<{ full? }>`
	display: block;
	position: absolute;
	z-index: 1;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);

	@media screen and (max-aspect-ratio: 1920/1080) {
		height: 100%;
	}

	@media screen and (max-width: 600px) {
		max-width: ${({ full }) => full && '100%'};
	}

	@media screen and (min-aspect-ratio: 1920/1080) {
		width: 100%;
	}
`
const Buttons = styled.div`
	position: absolute;
	left: 1rem;
	bottom: 0.5rem;
	display: flex;
	flex-direction: column;
`
const Button = styled.button`
	padding: 0.5rem;
	background: none;
	border: none;
	outline: none;
	z-index: 2;
	cursor: pointer;
	opacity: 0.8;
	color: ${({ theme: { colors } }) => colors.primary};

	:hover {
		opacity: 1;
	}

	:focus {
		outline: none;
	}
`
